<template>
  <div class="hours-column">
    <div class="header-hour">
      Godzina
    </div>
    <div
        v-for="hour in hoursArray"
        :key="hour"
        class="hour-cell"
    >
      {{ hour.representation }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

dayjs.extend(require('dayjs/plugin/utc'));

export default {
  name: 'HoursColumn',
  props: {
    data: Array,
    date: {
      type: Object,
      default: null,
    },
    endHour: Number, // full hour
    startHour: Number, // full hour
    step: Number, // in minutes
  },

  setup(props) {
    function hours() {
      const possibleHours = [];
      let date = dayjs().utc().hour(Number(props.startHour)).minute(0)
        .second(0)
        .millisecond(0);
      while (date.get('hour') < props.endHour || date.get('minute') === 0) {
        possibleHours.push({
          representation: date.format('HH:mm'),
          utc: date,
        });
        date = dayjs(date).add(props.step, 'minute');
      }
      return possibleHours;
    }
    const hoursArray = hours();

    return {
      hoursArray,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

  .hours-column {
    background-color: $white;
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    z-index: 30;
  }

  .header-hour {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    height: 45px;
    width: 60px;
  }

  .hour-cell {
    display: flex;
    flex-direction: column;
    height: 30px;
    justify-content: center;
    text-align: center;
    width: 60px;
  }

</style>
